import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    background: "#ffffff",
    overflow: "hidden",
    position: "relative",
    boxShadow: "8px 0px 24px rgba(0, 0, 0, 0.04)",
    "& .MuiSvgIcon-root": {
      color: "#022247",
    },
  },

  // Brand Header (Logo Area)
  brandHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: (props) => (props.sidebarOpen ? "space-between" : "center"),
    padding: "16px 20px",
    height: 70,
    boxSizing: "border-box",
    borderBottom: "1px solid #f1f5f9",
    position: "relative",
    overflow: "hidden",
  },
  brandLogoCont: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  logo: {
    width: 38,
    height: 38,
    objectFit: "cover",
    cursor: "pointer",
    borderRadius: "50%",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  brandName: {
    fontWeight: 700,
    fontSize: "14px",
    color: "#000",
    letterSpacing: "0.2px",
    textTransform: "uppercase",
    opacity: (props) => (props.sidebarOpen ? 1 : 0),
    transition: "opacity 0.25s ease",
  },

  // Floating Edge Toggle Button
  toggleButton: {
    position: "absolute",
    top: 23,
    right: 10,
    width: 34,
    height: 34,
    borderRadius: "30%",
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1100,
    cursor: "pointer",
    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      backgroundColor: "#f8fafc",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.12)",
      transform: "scale(1.08)",
    },
    [theme.breakpoints.down("md")]: {
      display: "none", // Hidden on small screens
    },
  },
  toggleIcon: {
    fontSize: "14px !important",
    color: "#022247 !important",
    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  toggleIconRotated: {
    transform: "rotate(180deg)",
  },

  // Scrollable Menu List Container
  menuListContainer: {
    flexGrow: 1,
    overflowY: "auto",
    overflowX: "hidden",
    paddingTop: 12,
    paddingBottom: 24,
    scrollbarWidth: "none", // Hide for Firefox
    "&::-webkit-scrollbar": {
      display: "none", // Hide for Chrome/Safari
    },
  },

  // Menu items list button
  listItemButton: {
    margin: "3px 12px !important",
    borderRadius: "8px !important",
    padding: "10px 16px !important",
    color: "#000000",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important",
    "&:hover": {
      background: "#f2f5f9 !important",
    },
  },

  menuIconCentered: {
    minWidth: "0px !important",
    width: "100%",
    justifyContent: "center",
    display: "flex",
    padding: "0px !important",
    transition: "all 0.3s ease",
    "& img": {
      width: 35,
      height: 35,
      objectFit: "contain",
    },
  },
  menuIcon: {
    minWidth: "32px !important",
    color: "#022247",
    display: "flex",
    alignItems: "center",
    transition: "all 0.3s ease",
    "& img": {
      width: 30,
      height: 30,
      objectFit: "contain",
    },
  },

  menuLabels: {
    transition: "opacity 0.3s ease",
    "& .MuiTypography-root": {
      color: "#000",
      fontWeight: 700,
      fontSize: "14px",
    },
  },
  menuLabels2: {
    transition: "opacity 0.3s ease",
    "& .MuiTypography-root": {
      fontWeight: 500,
      color: "#000",
      fontSize: "14px",
    },
  },

  // Submenu levels
  subMenuLabel: {
    "& .MuiTypography-root": {
      color: "#000000",
      fontSize: "13px",
    },
  },
  subitemscolor: {
    margin: "2px 12px 2px 20px !important",
    borderRadius: "8px !important",
    padding: "8px 16px !important",
    transition: "all 0.2s ease !important",
    "&:hover": {
      background: "#f2f5f9 !important",
    },
  },
  subitemsicon: {
    minWidth: "28px !important",
    "& img": {
      width: 30,
      height: 30,
      objectFit: "contain",
    },
  },
  subitemscontent: {
    margin: "2px 0px !important",
  },
}));

export default useStyles;


